import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { RequestRecognition } from '../shared/request-recognition.model';

@Component({
  selector: 'app-view-requests-assigned',
  templateUrl: './view-requests-assigned.component.html',
  styleUrls: ['./view-requests-assigned.component.scss']
})
export class ViewRequestsAssignedComponent implements OnInit, OnChanges {

  displayedColumns: string[] = ['fechaSolicitud', 'cedula', 'nombre', 'codPrograma', 'nomPrograma',
                  'version', 'codMateriaRecon', 'nomMateriaRecon', 'evaluador'];

  messageError: String = '';
  claseMessage: String = 'messaje-error';
  dataSource: MatTableDataSource<RequestRecognition>;

  @Input() requests: RequestRecognition[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor() {
    this.setTable();
  }

  ngOnInit() {
    this.setTable();
  }

  private setTable() {
    this.dataSource = new MatTableDataSource(this.requests);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

  }

  ngOnChanges() {
    this.setTable();
  }
}
